import CookieService from './general/cookie-service';
import { LessonStateCookie } from 'lesson-types';
import { ActiveQuizCookie } from 'quiz-types';

const ActiveLessonCacheService = {
  getLessonStateCookie(): LessonStateCookie | undefined {
    return CookieService.get('l-state') as unknown as LessonStateCookie;
  },

  setLessonStateCookie(data: LessonStateCookie): void {
    CookieService.set('l-state', data);
    return;
  },

  resetLessonStateCookie(): void {
    CookieService.delete('l-state');
    return;
  },

  getActiveQuizCookie(): ActiveQuizCookie {
    return CookieService.get('act-quiz') as unknown as ActiveQuizCookie;
  },

  setActiveQuizCookie(data: ActiveQuizCookie): void {
    CookieService.set('act-quiz', data);
  },

  resetActiveQuizCookie(): void {
    CookieService.delete('act-quiz');
  },
};

export default ActiveLessonCacheService;
